import { ListSortBy } from '@core/models/common/list-sort-by';
import { IListState, initialListState } from '../shared/list/list.state';
import { ListSortDirection } from '@core/models/common/list-sort-direction';

export interface IWorkplacesState {
    workplaces: IListState;
    viewedWorkplaceId: string;
}

export function initialWorkplacesState(): IWorkplacesState {
    return {
        workplaces: {
            ...initialListState,
            sortBy: ListSortBy.NAME,
            sortDirection: ListSortDirection.ASCENDING
        },
        viewedWorkplaceId: null
    };
};
